import React, { createContext, useContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [editUserData, setEditUserData] = useState(null);
  const [editCustomerData, setEditCustomerData] = useState(null);
  const [user, setUser] = useState({ email: '', role: '' });
  const [id, setId] = useState('');

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token && id) {
          const response = await fetch("http://103.61.224.178:8011/api/user/login", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            throw new Error('Failed to fetch user details');
          }

          const userDetails = await response.json();
          setUser(userDetails);
        }
      } catch (error) {
        console.error('Failed to fetch user details:', error);
      }
    };

    if (id) {
      fetchUserDetails();
    }
  }, [id]);

  return (
    <UserContext.Provider value={{ editUserData, setEditUserData, editCustomerData, setEditCustomerData, user, id, setId, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
